import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription, fromEvent } from 'rxjs';
import * as loginSelectors from '../../../../root-store/login-store/login.selector';
import { startWith, map } from 'rxjs/operators';
import * as selectorsRelationship from '../../../../root-store/relationship-store/relationship.selector';
import { UntypedFormControl } from '@angular/forms';
import { ReportService } from '@app/shared/services/report/report.service';
import { ConfigurationType } from '@app/shared/component/manage-element/manage-combo-element/enum';
import { ShareService } from '@app/shared/services/vault/share.service';
import { UserPermissionService, UserService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as selectors from '../../../../root-store/relationship-store/relationship.selector';
import { RootStoreState } from '@app/root-store';
//
import { fetchUserAttributes } from '@aws-amplify/auth';
import { EVENTS } from '@app/constants/events.constants';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'vault-setup-admin',
  templateUrl: './vault-setup-admin.component.html',
  styleUrl: './vault-setup-admin.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VaultSetupAdminComponent implements OnInit, OnDestroy {
  @Input() selectedStepInfo: any = {};
  @Input() personalVaultName;
  @Input() stepInfo: any = {};
  @Input() stateObject: any = {};
  @Input() selectedIndex;
  @Input() selectedVaultType;
  @Input() vaultAdmins = [];
  @Output() setVaultAdmins = new EventEmitter();
  @Input() isFromVault = false;
  @Input() userObject;

  connectionUserFormControl = new UntypedFormControl();

  screenWidth: number;
  resizeObservable$: Observable<Event>;
  subscription: Subscription = new Subscription();

  switchFromUser: boolean = false;

  options = [
    {
      value: 'Yes',
      isSelected: false,
    },
    {
      value: 'No',
      isSelected: false,
    },
  ];

  allUserConnections = [];
  selectedMember;
  nonProfessionalUsers = [];
  sub = new Subscription();
  isVaultSetupLoading = false;

  constructor(
    private cd: ChangeDetectorRef,
    private store: Store,
    private store$: Store<RootStoreState.State>,
    private _userService: UserService,
    private vaultShareService: ShareService,
    public userPermissionService: UserPermissionService,
    private toastr: ToastrService,
    private dialog: MatDialog
  ) {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetails).subscribe((data) => {
        this.selectedMember = data;
      })
    );
  }

  ngOnInit(): void {
    this.isVaultSetupLoading = true;
    this.cd.detectChanges();
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.subscription.add(
      this.store$.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe(async (result) => {
        try {
          if (result) {
            this.personalVaultName = result.nick_name;
            this.switchFromUser = true;
          }
          const authUser = await await fetchUserAttributes();
          if (result?.switch_from_user_id && result?.id != authUser['id']) {
            this.switchFromUser = true;
          } else {
            this.switchFromUser = false;
          }
        } catch (ex) {}
      })
    );

    this.getAdminData();
    if (!this.isFromVault) {
    } else {
      this.isVaultSetupLoading = false;
      this.nonProfessionalUsers = this.vaultAdmins;
      this.cd.detectChanges();
    }
  }

  getAdminData() {
    this.subscription.add(
      this.store.select(selectorsRelationship.getAndFilterNonProfessionalExcludeExistingUser('', [])).subscribe((data) => {
        let updatedObject = [];
        data.forEach((element, index) => {
          let tempEllemt = {
            ...element,
            name: '',
          };
          tempEllemt.id = element?.user_id;
          tempEllemt.name = element?.user_first_name + ' ' + element?.user_last_name;
          updatedObject.push(tempEllemt);
        });
        this.allUserConnections = [
          ...updatedObject.map(({ id, user_id, name, relationship_name, user_profile_image_url }) => ({
            id,
            user_id,
            name,
            relationship_name,
            user_profile_image_url,
            key: ConfigurationType.USERS,
          })),
        ];
        this.allUserConnections = this.allUserConnections.filter((d) => d.id !== this.selectedMember.id);
      })
    );
  }

  selectConnectedUser(user, isInvite) {
    this.connectionUserFormControl.disable();
    if (this.isFromVault) {
      this.nonProfessionalUsers = [...this.nonProfessionalUsers, user];
      this.setVaultAdmins.emit(this.nonProfessionalUsers);
      this.cd.detectChanges();
    } else {
      let data = {
        connection_status: user.connection_status,
        admin_status: true,
        grantee_user_id: user?.user_id ? user.user_id : user?.grantee_user_id,
        admin_all_information: true,
        from: 'vault_information',
      };
      if (this.stateObject?.id) {
        data['vault_id'] = this.stateObject?.id;
      }
      this.subscription.add(
        this.userPermissionService.adminAskAccessWithFolder(data).subscribe(async (results) => {
          this.toastr.success(`Admin permission granted.`);
          this.trackEventsInMixPanel('add');
          //refresh modal
          this.cd.detectChanges();
        })
      );
    }
  }

  deleteAdmin(existingUser) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Remove Admin Permission',
        materialIcon: 'delete',
        text: `Are you sure you want to remove ${existingUser.user_first_name} ${existingUser.user_last_name}'s Admin permission?`,
        proceedTitle: 'Remove',
      },
    });

    this.sub.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          if (this.isFromVault) {
            this.nonProfessionalUsers = this.nonProfessionalUsers.filter((item) => item.id != existingUser.id);
            this.setVaultAdmins.emit(this.nonProfessionalUsers);
            this.trackEventsInMixPanel('remove');
            this.cd.detectChanges();
          } else {
            this.deletpermission(existingUser);
          }

          // const pidLsit = Array.from(existingUser.permission_items ? existingUser.permission_items : []).map((p: any) => p);
          // let heartsIndex;
          // while ((heartsIndex = pidLsit.indexOf(this.modalData.folder.vault_folder_id.toString())) > -1) {
          //   pidLsit.splice(heartsIndex, 1);
          // }
          // const data = {
          //   grantee_user_id: existingUser.user_id,
          //   admin_status: true,
          //   permission_ids: pidLsit,
          // };
          // if (pidLsit.length == 0) {
          //   this.deletpermission(existingUser);
          // } else {
          //   this.updatePermission(data);
          // }
        }
      })
    );
  }

  deletpermission(params) {
    const dat1 = {
      grantee_user_id: params.user_id,
      admin_status: false,
      // vault_user_folder_id: this.modalData.folder.vault_user_folder_id,
      user_permissions_admins_id: params.user_permissions_admins_id,
    };
    this.sub.add(
      this.userPermissionService.DeletePermissionGrantDistributorAdmin(dat1).subscribe((res) => {
        this.toastr.success('Admin permission removed.');
        this.trackEventsInMixPanel('remove');
      })
    );
  }

  updatePermission(data) {
    if (this.stateObject?.id) {
      data['vault_id'] = this.stateObject?.id;
    }
    this.sub.add(
      this.userPermissionService.adminAskAccessWithFolder(data).subscribe(
        (res: any) => {
          // if (this.data?.isDeligate) {
          //   this.parentDialogRef.close({ data, isAdded: true, userfullname: this.full_name });
          // } else {
          //   this.toastr.success('Admin permission granted.');
          //   this.ngOnInit();
          // }
        },
        (error) => {}
      )
    );
  }

  handleSubFlow(response: string, flow: any) {
    this.options.forEach((opt) => {
      opt.isSelected = opt.value === response;
    });
    this.stepInfo[this.selectedVaultType][this.selectedIndex].answer = response;
    // this.discoveryData.answer = response;
    this.cd.detectChanges();
  }

  trackEventsInMixPanel(actionType) {
    const events =
      this.selectedVaultType === 'personal_vault'
        ? [{ eventName: EVENTS[`personal_vault_setup_${actionType}_admins_change`] }]
        : this.selectedVaultType === 'shared_vaults'
        ? [{ eventName: EVENTS[`shared_vault_setup_${actionType}_admins_change`] }]
        : this.selectedVaultType === 'entity_vault'
        ? [{ eventName: EVENTS[`entity_vault_setup_${actionType}_admins_change`] }]
        : [];
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.sub?.unsubscribe();
  }
}
